import React from "react";

export const Logo = ({ className = "w-11 h-11", light = false }) => (
  <img
    src={light ? "/logo-icon-light.png" : "/logo-icon.png"}
    alt="Szuper Szaki logó"
    className={`${className} object-contain`}
  />
);

export const Wordmark = ({ light = false }) => (
  <div className="flex flex-col items-start justify-center leading-none">
    <span className={`block font-display font-extrabold text-lg tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
      szuper-szaki<span className="text-orange-500">.hu</span>
    </span>
    <span className={`block mt-1.5 text-[10px] font-semibold tracking-[0.15em] uppercase ${light ? "text-sky-200" : "text-sky-600"}`}>
      Víz- &amp; Fűtésszerelés
    </span>
  </div>
);
